import React from 'react';

const characterSetControl = (props) => {
  const classes = ['characterSetIndicator', 'characterSetControl'];
  let buttonLabel;
  if (props.isTranslated) {
    classes.push('translatedYes');
    buttonLabel = 'Original';
  } else {
    classes.push('translatedNot');
    buttonLabel = 'Translate';
  }
  const labels = {
    'unknown': ['Either'],
    'simplified': ['Simplified'],
    'traditional': ['Traditional']
  };
  if (!props.visible) {
    classes.push('hidden');
  }
  return (
    <div className={classes.join(' ')}>
      <div className="characterSetLabel">Characters</div>
      <div className="characterSetValue">{labels[props.characterSet].join(' ')}</div>
      <button className="characterSetButton"
        disabled={!props.active}
        onClick={(e) => props.onTranslate(!props.isTranslated, e)}>{buttonLabel}</button>
    </div>
  );
};

export default characterSetControl;
